import { render, staticRenderFns } from "./XProcessesList.vue?vue&type=template&id=c9e63d28&"
import script from "./XProcessesList.vue?vue&type=script&lang=ts&"
export * from "./XProcessesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports